module.exports = __webpack_public_path__ + "img/clownpiece_sc2.8eb53b6c.png";